export const QR_CODE_API_URL = 'ui/organization/qr';
